import { breakPath, setDefaultStyle } from "apparatus/draw";
import { DEFAULT_LIQUID_DATA, Segments } from "apparatus/library/common";
import { Path } from "paper";
import { mirrorX } from "../draw";
export class BuchnerFunnel {
    render(appearance) {
        let radius = appearance.size;
        let upperHeight = radius * 0.5 + 30;
        let taperHeight = 0.5 * radius;
        let stem = 40;
        let mouthRadius = 6;
        var shape = new Path(Segments([[-radius, -taperHeight - upperHeight]], [[-radius, -taperHeight]], [[0, 0]], [[0, stem]]));
        mirrorX(shape, mouthRadius);
        let hitShape = shape.clone();
        let liquidMask = shape.clone();
        let graphic = breakPath(shape, 4);
        // Add filter layer.
        let filterLayer = new Path(Segments([[-radius, -taperHeight - 2]], [[radius + mouthRadius * 2, -taperHeight - 2]]));
        filterLayer.strokeWidth = 3;
        filterLayer.strokeCap = 'butt';
        filterLayer.dashArray = [3, 6];
        graphic.addChild(filterLayer);
        setDefaultStyle(graphic);
        return {
            graphic, hitShape, liquidMask,
            liquidDrainOpening: { start: liquidMask.segments[3].point, end: liquidMask.segments[4].point }
        };
    }
}
BuchnerFunnel.properties = {
    label: "Buchner Funnel",
    canContainLiquids: true,
    drainable: true,
    defaultAppearance: {
        size: 40
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "size", label: "Size",
            min: 30, max: 60,
        }
    ],
    defaultLiquidData: Object.assign(Object.assign({}, DEFAULT_LIQUID_DATA), { amountRatio: 0.7 })
};
